import ButtonBase from '@material-ui/core/ButtonBase';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { QuestionAndAnswer } from 'components-v2/organisms/QuestionAndAnswer';
import { BANNER2, COUNT_PRODUCT, MISSING_IMAGE } from 'constants/Images';
import { useAuth } from 'context/Auth';
import { useSetting } from 'context/Settings';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ProductServiceV2 from 'services/ProductServiceV2';
import { ImageFallbackProductImage, ImageFallbackStatic } from 'utils/ImageFallback';
import { getLinkProxyFile } from 'utils/ImageUtils';
import { getMedicineTypeLabels } from 'utils/ProductLabelUtils';
import { useStore } from 'zustand-lib/storeGlobal';
import LeftContent from '../LeftContent';

import styles from './styles.module.css';
import InfoProduct from './InfoProduct';

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M15.9233 7.16817C15.3861 5.90591 14.7082 4.81281 13.8897 3.88889C13.0711 2.96497 12.1567 2.25576 11.1463 1.76126C10.1359 1.25375 9.08713 1 8 1C6.91287 1 5.86411 1.25375 4.85372 1.76126C3.84333 2.25576 2.92886 2.96497 2.11031 3.88889C1.29177 4.81281 0.613909 5.90591 0.0767386 7.16817C-0.0255795 7.38939 -0.0255795 7.61061 0.0767386 7.83183C0.613909 9.09409 1.29177 10.1872 2.11031 11.1111C2.92886 12.035 3.84333 12.7507 4.85372 13.2583C5.86411 13.7528 6.91287 14 8 14C9.08713 14 10.1359 13.7528 11.1463 13.2583C12.1567 12.7507 13.0711 12.035 13.8897 11.1111C14.7082 10.1872 15.3861 9.09409 15.9233 7.83183C16.0256 7.61061 16.0256 7.38939 15.9233 7.16817ZM8 12.3799C6.73381 12.3799 5.53797 11.9439 4.41247 11.0721C3.28697 10.2002 2.3789 9.00951 1.68825 7.5C2.3789 5.99049 3.28697 4.7998 4.41247 3.92793C5.53797 3.05606 6.73381 2.62012 8 2.62012C9.26619 2.62012 10.462 3.05606 11.5875 3.92793C12.713 4.7998 13.6211 5.99049 14.3118 7.5C13.6211 9.00951 12.713 10.2002 11.5875 11.0721C10.462 11.9439 9.26619 12.3799 8 12.3799ZM8 4.24024C7.42446 4.24024 6.88729 4.38989 6.38849 4.68919C5.90248 4.97548 5.51239 5.37237 5.21823 5.87988C4.93685 6.37437 4.79616 6.91441 4.79616 7.5C4.79616 8.08559 4.93685 8.63213 5.21823 9.13964C5.51239 9.63413 5.90248 10.031 6.38849 10.3303C6.88729 10.6166 7.42446 10.7598 8 10.7598C8.57554 10.7598 9.10631 10.6166 9.59233 10.3303C10.0911 10.031 10.4812 9.63413 10.7626 9.13964C11.0568 8.63213 11.2038 8.08559 11.2038 7.5C11.2038 6.91441 11.0568 6.37437 10.7626 5.87988C10.4812 5.37237 10.0911 4.97548 9.59233 4.68919C9.10631 4.38989 8.57554 4.24024 8 4.24024ZM8 9.12012C7.56515 9.12012 7.18785 8.96396 6.86811 8.65165C6.56115 8.32633 6.40767 7.94244 6.40767 7.5C6.40767 7.05756 6.56115 6.68018 6.86811 6.36787C7.18785 6.04254 7.56515 5.87988 8 5.87988C8.43485 5.87988 8.80576 6.04254 9.11271 6.36787C9.43245 6.68018 9.59233 7.05756 9.59233 7.5C9.59233 7.94244 9.43245 8.32633 9.11271 8.65165C8.80576 8.96396 8.43485 9.12012 8 9.12012Z"
      fill="white"
    />
  </svg>
);

const ProductDetailNotLogin = ({ product, orderedCount, productWithoutLoginRecommend = [] }) => {
  const [productRecommendData, setProductRecommendData] = useState(productWithoutLoginRecommend ?? []);
  const { toggleLogin, toggleSignUp } = useAuth();
  const { imagesProxy, limitPerDay, messageLimitOrder, name, volume } = product;

  // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
  const medicineTypeLabels = getMedicineTypeLabels(product);

  // Prefer client-side fetched config (useSetting), fallback to SSR Zustand store
  const { configs } = useSetting();
  const appSettingFromStore = useStore((state) => state.appSetting);
  const bannerConfig = configs?.['DISPLAY_BANNER_CONFIG'] || appSettingFromStore?.['DISPLAY_BANNER_CONFIG'] || {};
  const banner2 = bannerConfig?.homeBanner2 || BANNER2;

  return (
    <Container style={{ maxWidth: '1304px' }} className={styles.containerNotLogin}>
      <Grid container spacing={3} className={styles.wrapper}>
        <Grid item xs={4}>
          <LeftContent
            product={product}
            imagesProxy={imagesProxy.length === 0 ? [MISSING_IMAGE] : imagesProxy}
            limitPerDay={limitPerDay}
            messageLimitOrder={messageLimitOrder}
          />
        </Grid>
        <Grid item className={styles.rightGrid} xs={5}>
          <Typography className={styles.typographyTitle} variant="h1">
            {name || ''}
          </Typography>
          {medicineTypeLabels.length > 0 && (
            <div className={styles.medicineType}>
              {medicineTypeLabels.map((info) => (
                <ImageFallbackStatic
                  key={info.variant}
                  src={info.icon.src}
                  height={20}
                  width={Math.round((info.icon.width / info.icon.height) * 20)}
                  alt={info.label}
                />
              ))}
            </div>
          )}
          <Typography className={styles.priceHidden}>
            <ButtonBase className={styles.viewPrice} onClick={toggleLogin}>
              <EyeIcon />
              {product.isIngredientSpecial ? 'Tư vấn' : 'Xem giá'}
            </ButtonBase>
          </Typography>
          <div className={styles.infoProduct}>
            {product.manufacturer?.name && (
              <div className={styles.flexItem}>
                <span className={styles.titleContent}>Nhà sản xuất</span>
                <div className={styles.infoTitleTop} onClick={toggleLogin} role="button">
                  <Typography className={styles.link}>{product.manufacturer?.name}</Typography>
                </div>
              </div>
            )}
            {product?.originName && (
              <div className={styles.flexItem}>
                <span className={styles.titleContent}>Nước sản xuất</span>
                <span className={styles.infoTitle}>{product?.originName}</span>
              </div>
            )}
            {product?.volume && (
              <div className={styles.flexItem}>
                <span className={styles.titleContent}>Quy cách</span>
                <span className={styles.infoTitle}>{volume}</span>
              </div>
            )}
            {product?.categories?.length > 0 && (
              <div className={styles.flexItem}>
                <span className={styles.titleContent}>Danh mục</span>
                {product?.categories?.map((category) => (
                  <div className={styles.infoTitle} onClick={toggleLogin} role="button">
                    <Typography className={styles.link}>{category.name}</Typography>
                  </div>
                ))}
              </div>
            )}
            {orderedCount > 0 && (
              <div className={styles.flexItem}>
                <span className={styles.titleContent}>Lượt mua trong 24h</span>
                <span className={styles.infoTitle}>{orderedCount} lượt</span>
              </div>
            )}
          </div>
        </Grid>
        <Grid item className={styles.rightGrid} xs={3}>
          <div className={styles.wrapperImageBanner}>
            <ImageFallbackStatic
              src={getLinkProxyFile(banner2)}
              width="298"
              height="167"
              size="large"
              alt="Dành cho khách hàng mới giảm 10% cho đơn hàng đầu tiên"
            />
          </div>
          <ButtonBase className={styles.registerNow} onClick={toggleSignUp}>
            <Typography className={styles.registerTitle}>Đăng ký ngay</Typography>
            <span className={styles.registerSubTitle}>để nhận ưu đãi</span>
          </ButtonBase>
        </Grid>
      </Grid>
      <Grid container className={styles.wrapper}>
        <Grid item xs={12}>
          <InfoProduct product={product} className={styles.infoContainerNotLogin} onClickBait={toggleLogin} />
        </Grid>
      </Grid>
      <Grid container className={styles.wrapper}>
        <Grid item xs={12}>
          <QuestionAndAnswer user={null} targetCode={product.sku} />
        </Grid>
      </Grid>
      <Grid container className={styles.clickBaitContainer}>
        <Grid item xs={12}>
          <div className={styles.titleTop}>
            <ImageFallbackStatic width={135} height={51} src={COUNT_PRODUCT} border="0" alt="Hơn 35000 SẢN PHẨM KHÁC ĐANG ĐỢI BẠN KHÁM PHÁ" />
            <span className={styles.textCount}>SẢN PHẨM KHÁC ĐANG ĐỢI BẠN KHÁM PHÁ</span>
          </div>
          {productRecommendData?.length > 0 && (
            <div className={styles.listProduct}>
              {productRecommendData?.map((item) => (
                <div className={styles.cardItem} onClick={toggleLogin} role="button">
                  <div className={styles.wrapperImage}>
                    <ImageFallbackProductImage
                      src={item?.defaultImage}
                      width="186"
                      height="186"
                      objectFit="contain"
                      size="medium"
                      alt={item?.name || ''}
                    />
                  </div>
                  <div className={styles.wrapperInfoProduct}>
                    <Typography className={styles.nameCard}>{item?.name || ''}</Typography>
                    <Typography className={styles.volume}>{item?.volume || ''}</Typography>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className={styles.wrapperButton}>
            <ButtonBase className={styles.clickBaitButton} onClick={toggleLogin}>
              Khám phá ngay
            </ButtonBase>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProductDetailNotLogin;
